import { useMemo } from 'react';
import useWindowDimensions from 'collaboration-sidebar/hooks/useWindowDimensions';
import { DEFAULT_WIDTH_CUTOFF } from '../constants/sidebar';
export default function useIsScreenWidthBelowThreshold() {
  "use memo";

  const {
    width
  } = useWindowDimensions();
  const isScreenWidthBelowThreshold = width < DEFAULT_WIDTH_CUTOFF;
  return isScreenWidthBelowThreshold;
}